import { DISPLAY_ORDER, lookupBrand } from './brandIconRegistry';

export type BrandLinkEntry = { type: string; value: string };

type ContactItem = { type?: string; value?: string } | null | undefined;
type SocialItem = { type?: string; link?: string } | null | undefined;

export type MergeableCV = {
  contact?: ContactItem[];
  socialMedia?: SocialItem[];
};

// Collapses CV contact[] and socialMedia[] into a single ordered list of
// {type, value} pairs for rendering as BrandIconLink icons. Ordering follows
// DISPLAY_ORDER from the registry; unknown types go to the end, preserving
// the order the user entered them.
export const mergeBrandEntries = (cv: MergeableCV): BrandLinkEntry[] => {
  const merged: BrandLinkEntry[] = [];
  (cv.contact ?? []).forEach((c) => {
    if (c?.type && c?.value) merged.push({ type: c.type, value: c.value });
  });
  (cv.socialMedia ?? []).forEach((s) => {
    if (s?.type && s?.link) merged.push({ type: s.type, value: s.link });
  });
  const rank = (entry: BrandLinkEntry): number => {
    const brand = lookupBrand(entry.type);
    if (!brand) return DISPLAY_ORDER.length;
    const idx = DISPLAY_ORDER.indexOf(brand.key);
    return idx >= 0 ? idx : DISPLAY_ORDER.length;
  };
  return merged
    .map((entry, i) => ({ entry, i }))
    .sort((a, b) => {
      const ra = rank(a.entry);
      const rb = rank(b.entry);
      return ra === rb ? a.i - b.i : ra - rb;
    })
    .map(({ entry }) => entry);
};
